import { render } from "./Contactos.vue?vue&type=template&id=4ec12162&scoped=true"
import script from "./Contactos.vue?vue&type=script&lang=js"
export * from "./Contactos.vue?vue&type=script&lang=js"

import "./Contactos.vue?vue&type=style&index=0&id=4ec12162&lang=scss&scoped=true"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec12162"]])

export default __exports__